<div class="content-wrapper min-h-[714px]" *ngIf="!showProfileConfiguration">


    <div class="flex justify-between w-full px-9">
        <div class="flex flex-row mb-8">
            <button (click)="closeDetails()" class="w-fit  mr-4"><i
                    class="far fa-chevron-left text-white text-2xl"></i></button>
            <p *ngIf="!isCreate" class="text-white text-2xl">Ver Perfil de configuración: <span class="text-accent">{{
                    profile.name }}</span>
            </p>
            <p *ngIf="isCreate" class="text-white text-2xl">Nuevo Perfil</p>
        </div>
        <app-accent-button *ngIf="!isEdit && !isCreate && isBasicInfo" class="h-10" text="Editar"
            icon="fa-regular fa-pen-to-square mr-2" [selected]="true" (click)="editLine()"></app-accent-button>
        <div *ngIf="isEdit && isBasicInfo" class="flex">
            <app-accent-button class="h-10 mr-4" text="Cancelar" icon="fa-regular fa-xmark mr-2" [selected]="false"
                (click)="cancelEdit()"></app-accent-button>
            <app-accent-button class="h-10" text="Guardar" icon="fa-regular fa-floppy-disk mr-2" [selected]="true"
                (click)="saveLine()"></app-accent-button>
        </div>
        <app-accent-button *ngIf="isCreate" class="h-10" text="Crear" icon="fa-light fa-circle-plus mr-2"
            [selected]="true" (click)="saveLine()"></app-accent-button>
        <app-accent-button *ngIf="!isBasicInfo" class="h-10" text="Guardar cambios" icon="fa-light fa-circle-plus mr-2"
            [selected]="true" (click)="updateProfileLines()"></app-accent-button>
    </div>
    <div class="w-full h-[1px] bg-tertiary"></div>
    <div class="flex gap-3 p-9 pt-4" *ngIf="!isCreate">
        <app-accent-button class="h-10" text="Información básica" [selected]="isBasicInfo"
            (click)="basicInfo()"></app-accent-button>
        <app-accent-button class="h-10" text="Líneas asociadas" [selected]="!isBasicInfo && asociatedLines"
            (click)="associatedLines()" icon="fa-light fa-table-list mr-2"></app-accent-button>
        <app-accent-button class="h-10" text="Líneas no asociadas" [selected]="!isBasicInfo && !asociatedLines"
            (click)="unassociatedLine()" icon="fa-light fa-table-list mr-2"></app-accent-button>

    </div>
    <!-- <div *ngIf="loading" class="loading-wrapper">
        <mat-spinner></mat-spinner>
        <p>Cargando...</p>
      </div> -->
    <div class="p-9 pt-4" *ngIf="isBasicInfo">
        <div class="flex flex-row mb-10">
            <div class="w-2/5">
                <p class="text-grey mb-2">Nombre</p>
                <p *ngIf="!isCreate && !isEdit" class="text-white">{{profile.name}}</p>
                <input type="text" *ngIf="isCreate || isEdit" [(ngModel)]="name" placeholder="Nombre">
            </div>
            <div class="w-2/5">
                <p class="text-grey mb-2">Líneas asociadas</p>
                <p class="text-white">{{ numberofLines }}</p>
            </div>
        </div>
        <div class="flex flex-row mb-10">
            <div class="w-2/5">
                <p class="text-grey mb-2">Configuración</p>
                <button class="px-3 py-2 border rounded-button bg-transparent text-accent border-accent cursor-pointer"
                    (click)="openConfiguration()">
                    Ver configuración
                </button>
            </div>
            <div class="w-2/5" *ngIf="!isCreate">
                <p class="text-grey mb-2">Eliminar</p>
                <button *ngIf="isEdit" class="px-3 py-2 border rounded-button border-danger text-danger cursor-pointer"
                    (click)="deleteProfile()">
                    Eliminar
                    <i class="fa-regular fa-trash ml-6"></i>
                </button>
                <button *ngIf="!isEdit"
                    class="px-3 py-2 border rounded-button cursor-default bg-quaternary border-tertiary text-tertiary">
                    Eliminar
                    <i class="fa-regular fa-trash ml-6"></i>
                </button>
            </div>
        </div>

    </div>
    <app-my-lines *ngIf="!isBasicInfo && asociatedLines" [selectedProfile]="profile"
        (linesSelected)="getLinesSelected($event)"></app-my-lines>
    <app-my-lines *ngIf="!isBasicInfo && !asociatedLines" [selectedProfile]="profile"
        (linesSelected)="getLinesSelected($event)" [isInside]="false"></app-my-lines>
</div>

<app-configure-telephone-line *ngIf="showProfileConfiguration" [line]="showProfileConfiguration"
    (changeConfiguration)="closeConfiguration($event)" (profileSettings)="getSettings($event)"
    [profile]="profile"></app-configure-telephone-line>